<template>
  <div class="bg-white shadow-sm shadow-sm-hover rounded">
    <button
      @click="toggleOpen"
      class="btn btn-reset w-100 shadow-none text-left p-2 p-sm-3 d-flex justify-content-between mb-0"
    >
      <p class="flex-grow-1 h5 mb-0 pr-2">{{ question }}</p>
      <ChevronDown :class="isOpen ? 'rotate-180' : ''" class="mt-1 expand-icon svg-16" />
    </button>
    <transition name="fade">
      <div v-show="isOpen" class="p-2 p-sm-3 mt-n2 mt-sm-n3">
        <div class="text-muted mb-0"><slot></slot></div>
      </div>
    </transition>
  </div>
</template>

<script>
import ChevronDown from "../../icons/atalanda/chevron-down.svg";

export default {
  name: "FAQItem",
  components: {
    ChevronDown,
  },
  props: {
    question: {
      type: String,
      required: true,
    },
    initialOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.initialOpen,
    };
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.expand-icon {
  transition: transform $transition-duration;
}

.rotate-180 {
  transform: rotate(180deg);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
